import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import moment from 'moment-timezone';
import { Observable } from 'rxjs';

import { LocalizationService } from '../services/localization.service';

@Injectable()
export class LocalizationInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const localizationService = this.injector.get(LocalizationService);
    const culture = localizationService.getCurrentLanguage();

    const localizationReq = req.clone({
      headers: req.headers.append('lang', culture).append('TimeZone', moment.tz.guess()),
    });

    return next.handle(localizationReq);
  }
}
